module.exports = __webpack_public_path__ + "static/0053-4d21b29b38c488ca89151e72e514138b.png";